import React from "react";

const UnAuthHeader = () => {
  return <></>;
};

export default UnAuthHeader;
